import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  Table,
  Badge,
  Button as BsButton,
  Container,
  Accordion,
} from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import patientService from "../../services/patient.service.js";
import AllocateService from "../AllocateService.js";
import moment from "moment";
import { DateFormat, TooltipLink, calculateSum } from "../../Helper.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../shared/Loading.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../context/AppContext.js";
import { useContext } from "react";
import IPDRegistration from "./IPDRegistration.js";
import DemographicInfo from "../../shared/users/DemographicInfo.js";
import AppointmentBooking from "../../appointmentBooking/AppointmentBooking.js";
import Bookings from "../../appointmentBooking/Bookings.js";
import bpService from "../../services/bp.service.js";
function PatientDetail() {
  const navigate = useNavigate();
  let { patientId } = useParams();
  const [setLoaderActive, toast] = useContext(AppContext);
  // console.log(patientId);
  //urls used in this component
  if (patientId === undefined) patientId = 1;

  const [isLoading, setIsLoading] = useState(true);
  const [patient, setPatient] = useState({});
  const [ipdAdmissionModal, setIpdAdmissionModal] = useState(false);
  const [show, setShow] = useState(false);
  const [bookingModal, setBookingModal] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [branches, setBranches] = useState([]);
  async function newIpdAdmission(data) {
    setIpdAdmissionModal(false);
    console.log(data);
    const invoice = {
      invoiceId: 0,
      admissionId: data.invoiceId,
      patientId: patient.bpPatientId,
      items: [
        {
          timestamp: Date.now(),
          name: "IPD Admission",
          availDate: moment().format("yyyy/MM/DD"),
          quantity: 1,
          rate: 1000,
          subtotal: 1000,
          id: 0,
        },
      ],
      open: true,
    };
    await handleInvoice(invoice);
    setPatient({ ...patient, inPatient: true });
  }
  useEffect(() => {
    async function fetchInitialData() {
      try {
        const patientData = await patientService.getPatientUser(patientId);
        const branchList = await bpService.getBranches();
        setBranches(branchList);
        setPatient(patientData);
        if (
          patientData.patient &&
          patientData.invoices &&
          patientData.invoices.length > 0
        ) {
          var openInvoice = patientData.invoices[0];
          openInvoice = await patientService.getOrder(
            openInvoice.bp_service_order_base_id,
            patientId
          );
          if (openInvoice)
            openInvoice.due = openInvoice.grand_total - openInvoice.paid;
          setInvoices((i) => [{ ...openInvoice }]);
          const items = [...openInvoice.order_items];
          setAdviceNoted((a) => items);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading("error");
        toast.error("Something went wrong! Try Again!");
      }
    }
    fetchInitialData();
  }, [patientId, toast]);

  const [adviceNoted, setAdviceNoted] = useState([]);

  const [invoices, setInvoices] = useState([]);

  const payerRef = useRef(null);

  const handleInvoice = async (invoice) => {
    // invoice.gross_base_price = calculateSum(
    //   invoice.order_items,
    //   "item_base_price"
    // );
    // invoice.bp_br_bill_num = invoice.timestamp;
    invoice.gross_item_discount = calculateSum(
      invoice.order_items,
      "item_discount_amount",
      "canceled"
    );
    invoice.gross_item_taxable = calculateSum(
      invoice.order_items,
      "taxable_amount",
      "canceled"
    );
    invoice.gross_gst = calculateSum(
      invoice.order_items,
      "gst_amount",
      "canceled"
    );
    invoice.other_charges = 0;
    invoice.other_discounts = 0;
    invoice.grand_total = calculateSum(
      invoice.order_items,
      "subtotal",
      "canceled"
    );
    invoice.paid = invoice.bp_service_order_base_id === 0 ? 0 : invoice.paid;

    try {
      setIsLoading(true);
      // requestOptions.body = JSON.stringify(invoice);
      // const response = await fetch(invoiceUrl, requestOptions);
      // const data = await response.json();
      invoice = await patientService.processServiceOrder(invoice);
      if (invoice.payments !== undefined && invoice.payments.length > 0) {
        invoice.paid = calculateSum(invoice.payments, "amount");
      }
      invoice.due = invoice.grand_total - invoice.paid;

      if (invoice.is_open) {
        setAdviceNoted(invoice.order_items);
      }
      if (!patient.patient?.bp_patient_id && invoice.patient) {
        setPatient({ ...patient, patient: invoice.patient });
      }
      let newInvoices = invoices.filter(
        (i) => i.bp_service_order_base_id !== invoice.bp_service_order_base_id
      );

      setInvoices([...newInvoices, invoice]);
      // console.log(data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading("error");
    }
  };

  const cancelNewService = () => {
    console.log(payerRef.current);
    if (adviceNoted.length === 0) {
      setShow(false);
      return false;
    }
    // let oldItems = adviceNoted.filter(
    //   (i) => i.bp_service_order_item_id == true
    // );
    if (invoices && invoices.length > 0) {
      var openInvoice = invoices.find((i) => i.is_open);
      setAdviceNoted([...openInvoice.order_items]);
      setShow(false);
      return false;
    }
    // setAdviceNoted((oldItems) =>
    //   oldItems.filter((i) => i.bp_service_order_item_id !== undefined)
    // );
    // setShow(false);
    // return false;
  };

  const handleModalClose = async (invoiceClose) => {
    if (adviceNoted.length === 0) {
      setShow(false);
      return false;
    }

    let openInvoice = invoices.filter((i) => i.is_open === true);
    if (openInvoice.length === 0) {
      // const bp = localdataService.getDefaultBp();
      openInvoice = {
        bp_service_order_base_id: 0,
        // bp_sys_id: null,
        // bp_br_id: bp.bp_br_id,
        kapid_user_id: patientId,
        bp_patient_id: patient.patient?.bp_patient_id,
      };
    } else openInvoice = openInvoice[0];

    openInvoice.is_open = !invoiceClose;
    openInvoice.order_items = adviceNoted;
    if (invoiceClose) setAdviceNoted([]);
    await handleInvoice(openInvoice);

    // openInvoice.items = adviceNoted;

    // let newInvoices = invoices.filter(i=>i.open === false);
    // setInvoices([...newInvoices,openInvoice]);
    setShow(false);
  };

  const completeInvoice = async () => {
    let openInvoice = invoices.filter((i) => i.is_open === true);
    if (openInvoice.length === 0) return false;
    else openInvoice = openInvoice[0];

    openInvoice.is_open = false;
    setAdviceNoted([]);

    await handleInvoice(openInvoice);

    // openInvoice.items = adviceNoted;
    // let newInvoices = invoices.filter(i=>i.open === false);
    // setInvoices([...newInvoices,openInvoice]);
  };

  const serviceProps = {
    adviceType: "Service",
    variant: "primary",
    id: "newAddService",
    // data: serviceMaster,
    typeaheadId: "servicesearchbar",
    adviceNoted: adviceNoted,
    setAdviceNoted: setAdviceNoted,
    kapid_user_id: patientId,
    fields: [
      {
        label: "Date",
        props: {
          type: "date",
          required: true,
          defaultValue: moment().format("yyyy-MM-DD"),
        },
        ref: "availDate",
      },
      {
        label: "Base Price",
        props: { type: "number", required: true, min: 0 },
        ref: "rate",
        readOnly: true,
      },
      {
        label: "Quantity",
        props: { type: "number", required: true, defaultValue: 1, min: 1 },
        ref: "quantity",
      },
      {
        label: "Discount",
        props: { type: "number", defaultValue: 0, min: 0 },
        ref: "discount",
      },
      {
        label: "Subtotal",
        props: { type: "number" },
        ref: "subtotal",
        readOnly: true,
      },
      {
        label: "Detail",
        props: { as: "textarea", rows: 1 },
        ref: "detail",
        hidden: true,
      },
    ],
  };

  async function newBooking(eventData) {
    const booking_data = {
      bp_br_id: eventData.bp_br_id,
      bp_br_activity_id: eventData.bp_br_activity_id,
      // requester_source_id:int,
      bp_br_activity_schedule_id: eventData.bp_br_activity_schedule_id,
      from_date: eventData.startStr,
      to_date: eventData.endStr,
      activity_booking_status: "created",
      // bp_br_activity_booking_id:int|None=None
      bp_patient_id: patient.patient?.bp_patient_id,
      // bp_user_map_id:int|None=None
      // patient: mcare_patient_schema | None = None
      kapid_user_id: patientId,
    };
    console.log(booking_data);
    const booking = await patientService.bookActivity(booking_data);
    console.log(booking);
    setBookings((b) => [...b, eventData]);
    setBookingModal(false);

    // setBookingModal(false);
  }

  // return <Loading failed={true} />
  if (isLoading === true) {
    return <Loading />;
  } else if (isLoading === "error") {
    return <Loading failed={true} />;
  }

  return (
    <Container>
      <ul className="sticky-ul-container d-print-none">
        {!patient.inPatient && (
          <TooltipLink title={"New Admission"} id={"newAdmission-tooltip"}>
            <BsButton
              className="sticky-li bg-danger"
              onClick={() => {
                setIpdAdmissionModal(true);
              }}
              as="li"
              variant="danger"
            >
              NA
            </BsButton>
          </TooltipLink>
        )}

        <TooltipLink title={"Erx"} id={"erx-tooltip"}>
          <BsButton
            className="sticky-li bg-success text-light"
            onClick={() => navigate(`/erx/${patientId}/1`)}
            as="li"
            variant="light"
          >
            ErX
          </BsButton>
        </TooltipLink>
        <TooltipLink title={"Service Booking"} id={"serviceBooking-tooltip"}>
          <BsButton
            className="sticky-li bg-warning text-dark"
            onClick={() => setBookingModal(true)}
            as="li"
            variant="light"
          >
            SB
          </BsButton>
        </TooltipLink>
        <TooltipLink title={"New Service"} id={"newService-tooltip"}>
          <BsButton
            className="sticky-li bg-info"
            onClick={() => setShow(true)}
            as="li"
            variant="light"
          >
            NS
          </BsButton>
        </TooltipLink>
      </ul>
      <DemographicInfo
        user={patient}
        user_type={"patient"}
        border={patient.patient ? null : "danger"}
      />
      <Bookings bookings={bookings} />
      {invoices && invoices.length > 0 && (
        <>
          <Accordion>
            {invoices.map(function (invoice, index) {
              return (
                <Accordion.Item
                  key={index}
                  eventKey={index}
                  className="border border-primary"
                >
                  <Accordion.Header>
                    <h4 className="card-title">
                      Invoice No : {invoice.bp_br_bill_num} | Total :{" "}
                      {invoice.grand_total} | Due : {invoice.due}{" "}
                      {invoice.is_open && <Badge bg="success">Open</Badge>}{" "}
                    </h4>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Table responsive striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>Service</th>
                          <th>Date</th>
                          <th className="text-end">Quantity</th>
                          <th className="text-end">Rate</th>
                          <th className="text-end">Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.order_items.map((service) => {
                          return (
                            <tr key={service.timestamp}>
                              <td>
                                {service.item_service_details.bp_service_name}
                              </td>
                              <td>
                                <DateFormat
                                  value={service.avail_date}
                                  dateTime={true}
                                />
                              </td>
                              <td className="text-end">
                                {service.item_quantity}
                              </td>
                              <td className="text-end">
                                {service.unit_net_price}
                              </td>
                              <td className="text-end">{service.subtotal}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot className="text-end fw-bold">
                        <tr>
                          <td colSpan={4}>Total</td>
                          <td>{invoice.grand_total}</td>
                        </tr>
                        <tr>
                          <td colSpan={4}>Paid</td>
                          <td>{invoice.paid}</td>
                        </tr>
                        <tr>
                          <td colSpan={4}>Due</td>
                          <td>{invoice.due}</td>
                        </tr>
                        <tr>
                          <td colSpan={5}>
                            {invoice.is_open && (
                              <BsButton
                                variant="success"
                                className="me-3"
                                onClick={() => completeInvoice()}
                              >
                                Complete
                              </BsButton>
                            )}

                            <Link
                              to={`/patient/${patientId}/collect/${invoice.bp_service_order_base_id}`}
                              target="_blank"
                              className="btn btn-primary me-3"
                              rel="noopener noreferrer"
                            >
                              Payments{" "}
                              <FontAwesomeIcon icon="fa-solid fa-arrow-up-right-from-square" />
                            </Link>
                            <Link
                              to={`/patient/${patientId}/invoice/${invoice.bp_service_order_base_id}`}
                              target="_blank"
                              className="btn btn-info"
                              rel="noopener noreferrer"
                            >
                              Invoice{" "}
                              <FontAwesomeIcon icon="fa-solid fa-arrow-up-right-from-square" />
                            </Link>
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </>
      )}

      <Modal
        show={show}
        onHide={() => cancelNewService()}
        backdrop="static"
        keyboard={false}
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Service</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AllocateService {...serviceProps} />
        </Modal.Body>
        <Modal.Footer>
          <BsButton variant="success" onClick={() => handleModalClose(true)}>
            Complete
          </BsButton>
          <BsButton variant="primary" onClick={() => handleModalClose(false)}>
            Save Draft
          </BsButton>
          <BsButton variant="secondary" onClick={() => cancelNewService()}>
            Cancel
          </BsButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={ipdAdmissionModal}
        onHide={() => setIpdAdmissionModal(false)}
        backdrop="static"
        keyboard={false}
        fullscreen
      >
        <Modal.Header closeButton className="p-2">
          <Modal.Title>
            IPD Admission - {patient.patientName} ({patient.kapidId})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {/* <DemographicInfo patient={patient} /> */}
            <Card className="bg-new">
              {/* <Card.Header as="h5">Other information</Card.Header> */}
              <Card.Body>
                <IPDRegistration onNewAdmission={newIpdAdmission} />
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
        <Modal.Footer className="p-0">
          <BsButton
            variant="secondary"
            onClick={() => setIpdAdmissionModal(false)}
          >
            Cancel
          </BsButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={bookingModal}
        onHide={() => setBookingModal(false)}
        backdrop="static"
        keyboard={false}
        fullscreen
        // size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>New Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AppointmentBooking onSelect={newBooking} branches={[...branches]} />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default PatientDetail;
